module.exports = __webpack_public_path__ + "static/media/spm-result.47aa1f3d.png";